import { Component, input, OnInit, output, signal } from '@angular/core';
import { IconModule, NotifyComponent } from '@agilox/ui';
import { State, States } from '@agilox/ui-common';

@Component({
	selector: 'toast',
	imports: [IconModule, NotifyComponent],
	templateUrl: './toast.component.html',
})
export class ToastComponent implements OnInit {
	type = input<State>(States.Info);
	text = input<string>('');
	closable = input<boolean>(false);
	timer = input<number | undefined>();

	closeNotify = output<void>();
	pauseNotify = output<void>();
	restartNotify = output<void>();

	currentProgress = signal<number>(100);

	private intervalId?: ReturnType<typeof setInterval>;

	ngOnInit(): void {
		this.startProgress();
	}

	onMouseOver() {
		this.pauseNotify.emit();
		this.clearProgress();
	}

	onMouseOut() {
		this.restartNotify.emit();
		this.startProgress();
	}

	private startProgress() {
		this.clearProgress();
		const seconds = this.timer() ?? 0;

		if (seconds <= 0) {
			this.currentProgress.set(0);
			return;
		}
		this.currentProgress.set(100);

		const step = 100 / (seconds * 10);
		this.startInterval(step);
	}

	private startInterval(step: number) {
		this.intervalId = setInterval(() => {
			const next = this.currentProgress() - step;
			if (next <= 0) {
				this.clearProgress();
			} else {
				this.currentProgress.set(next);
			}
		}, 100);
	}

	private clearProgress() {
		if (this.intervalId) {
			clearInterval(this.intervalId);
			this.intervalId = undefined;
			this.currentProgress.set(0);
		}
	}
}
